import React, {PropTypes} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import QCapTable from './QCapTable';
import Checkbox from 'material-ui/Checkbox';
import axios from 'axios';

class QCapHome extends React.Component {

    constructor() {

      super();
      this.state ={myRating: [],manager: false,myTeamRating: [],indirect: false,loading: false}
      this.updateTeam = this.updateTeam.bind(this);
    }

    componentDidMount()
    {
      let empId,request;
      if(!this.props.hrbp) {
        empId = this.props.employee.empno;
        request = {empId: empId,type:"direct" }
      }
      else
      {
        request = {empId: 11,type:"indirect" }
      }
      this.setState({loading: true});
      axios.get(process.env.REQ_URL + "/qcap/getRatingsForTeam?q="+JSON.stringify(request), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
         this.setState({myRating: response.data.data})
        this.setState({loading: false});

      }).catch((error) => {

      });
    }

    updateTeam(check)
    {
      let empId = this.props.employee.empno;
      let request = {empId: empId,type:check };
      this.setState({loading: true});
      axios.get(process.env.REQ_URL + "/qcap/getRatingsForTeam?q="+JSON.stringify(request), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        this.setState({loading: false});
        this.setState({myRating: response.data.data})
      }).catch((error) => {

      });

    }
    render() {
        return (<div>
            <div className="col-md-12">
             <h2>My Reporting Team Rating</h2>
            {this.state.loading? <font> Loading... </font>: null}
            </div>
            <div className="col-sm-6">
              {!this.props.hrbp?  <Checkbox label="Indirect"
                        style={{width: '100%', marginTop: '20px'}}
                        onCheck={()=> {
                          let state = this.state.indirect;
                          this.setState({indirect: !this.state.indirect});
                          if(state)
                            this.updateTeam("direct");
                          else
                            this.updateTeam("indirect");

                        }}
                        checked={this.state.indirect}
                        iconStyle={{boxColor: '#FADFFF'}}/>:null}
            </div>
            <QCapTable data={this.state.myRating}/>



        </div>
        );
    }
}

QCapHome.propTypes = {};

export default QCapHome;





/** WEBPACK FOOTER **
 ** ./src/feature/qcap/QCapTeamHome.js
 **/